export class AppError extends Error {
  constructor(message: string, code?: string) {
    super(message);
    this.name = code || this.name;
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/app-error.model.ts